import { sv } from 'date-fns/locale';
import React, { useEffect, useMemo } from 'react';
import { DateRange } from 'react-date-range';
import styled from 'styled-components';

export function Datepicker({
    startDate,
    endDate,
    hideClearButton,
    onChange,
    onClear,
}) {
    const ranges = useMemo(() => {
        return [
            {
                startDate: startDate || new Date(),
                endDate: endDate || new Date(), // Tomorrow
                key: 'selection',
            },
        ];
    }, [startDate, endDate]);

    const calendarColorChange = () => {
        const days = document.querySelectorAll('.rdrDay ');
        setTimeout(() => {
            days.forEach(day => {
                day.style.backgroundColor = '#ffffff';
                day.style.borderRadius = 'none';
                for (let i = 0; i < day.children.length; i++) {
                    if (
                        startDate != null &&
                        (
                            day.children[i].classList.contains('rdrStartEdge') ||
                            day.children[i].classList.contains('rdrEndEdge')
                        )
                    ) {
                        day.style.backgroundColor = '#4AA3C8';
                        day.style.borderRadius = '99999px';
                    }

                    if (day.classList.contains('rdrDayPassive') &&
                        day.children[i].classList.contains('rdrInRange')) {
                        day.classList.toggle('rdrDayPassive');
                    }

                    if (day.classList.contains('rdrDayPassive') &&
                        day.children[i].classList.contains('rdrEndEdge')) {
                        day.classList.toggle('rdrDayPassive');
                    }
                }
            });

            if (startDate == null) {

            }
        }, 0.1);
    };

    useEffect(calendarColorChange, [startDate, endDate]);

    return (
        <Wrapper>
            <DateRange
                locale={sv}
                ranges={ranges}
                editableDateInputs={true}
                onChange={item => onChange(
                    item.selection.startDate,
                    item.selection.endDate,
                )}
                moveRangeOnFirstSelection={false}
                rangeColors={['rgba(74, 162, 200, 0.2)']}
                color="#4AA3C8"
                showMonthAndYearPickers={false}
                shownDate={null}
                initialFocusedRange={null}
                minDate={new Date()}
                className={startDate == null ? 'no-date' : ''}
                showSelectionPreview={false}
                dateDisplayFormat="yyyy-MM-dd"
                startDatePlaceholder="YYYY-MM-DD"
                endDatePlaceholder="YYYY-MM-DD"
                weekStartsOn={1}
                onShownDateChange={() => calendarColorChange()}
            />
            {!hideClearButton &&
                <button
                    className="clear-dates"
                    onClick={onClear}
                >
                    Rensa datum
                </button>
            }
        </Wrapper>
    );
}

const Wrapper = styled.div`
    margin-inline: auto;

    .rdrDateDisplayItem {
        box-shadow: none;

        font-size: 14px;

        @media (min-width: 1024px) {
            font-size: 16px;
        }
    }

    .clear-dates {
        display: block;
        cursor: pointer;
        text-align: center;
        width: 100%;
        border: none;
        background: white;
        color: #000000;
        font-size: 16px;
        text-decoration: underline;
        margin-top: 8px;
        margin-bottom: 16px;
    }
`;
